/* eslint-disable */
import React, { Fragment, useRef, useEffect, useState } from "react";
import { Link, NavLink, Switch, Route, Redirect } from "react-router-dom";
import {
  BellOutlined,
  QuestionCircleOutlined
} from "@ant-design/icons";
import { Button, Spin, Badge, Popover } from "antd";
import _ from "lodash";
import manager from 'pages/manager'
import HeaderBar from '../components/headerbar'
import UserContextWrapped, { withUser } from '../context/user'
import UserBox from './components/userBox'

import cookies from "js-cookie";
import MyCompanys from './components/myCompanys'
import NavLayout from './components/navLayout'
import * as qs from "query-string";
import { getInformOutLines, searchNotice, readedNotice } from "apis/notice"
import './index.css'

import NoticeInfoAlert from "pages/user/notice/infoAlert"
import company from "pages/company";
import userSelf from "pages/user";
import { loginAfterUrl } from 'pages/config'

// import notice from "pages/notice"
// import NavMenu from "jcb-nav-menu";

const importPages = [userSelf, manager, company];
// const { Messages } = NavMenu;

const pageMap = new Map();
importPages.forEach(p => {
  const comp = createPage(p);
  if (Array.isArray(p.prefix)) {
    p.prefix.forEach(q => pageMap.set(q, comp));
  } else {
    pageMap.set(p.prefix, comp);
  }
});
/**
 * 创建page组件
 * @param {*} config
 */
function createPage(config) {
  // 默认导航到第一个内容中
  const flow = [
    ({ user, location }) => {
      // console.log(user.self.companySpecialAccount)
      // 子账号信息
      const isAccount = user.self.companySpecialAccount;
      // 过滤掉'我的钱包'导航
      let filter = config.pages.filter(
        (item) => item.name !== "我的钱包"
      );
      // 是否是子账号
      const page = isAccount ? (filter.find(p => p.path === location.pathname)) : (config.pages.find(p => p.path === location.pathname));
      // console.log(page, location)
      if (!page) {
        return null;
      }
      return <Redirect to={{
        ...location,
        pathname: page.children[0].path
      }} />;
    }
  ];
  // const flow = [
  //   ({ user, location }) => {
  //     const flattenArray = [...config.pages.map(x => x.children).flatMap(x => {
  //       x.children = []
  //       return x
  //     }), ...config.pages]
  //     console.log(flattenArray)
  //     // console.log('createPage Page', user, location)
  //     const page = flattenArray.find(p => p.path === location.pathname);
  //     console.log(page, location)
  //     if (!page) {
  //       return null;
  //     }
  //     console.log(!page.children || !page.children[0] )
  //     if (!page.children || !page.children[0]) {
  //       return <Redirect to={{
  //         ...location,
  //         pathname: page.path
  //       }} />
  //     } else {
  //       return <Redirect to={{
  //         ...location,
  //         pathname: page.children[0].path
  //       }} />;
  //     }
  //   }
  // ];

  config.init && flow.push(config.init);

  const comp = _.wrap(flow, function (flow, props) {
    for (const func of flow.reverse()) {
      const res = func(props);
      if (res != null) {
        return res;
      }
    }
    return null;
  });

  // 生成headerLeft
  comp.HeaderLeft = () => (
    <Route
      path={config.prefix}
      render={({ location }) => {
        // console.log('HeaderLeft', location)
        // console.log('config.pages', config.pages)
        return config.pages.map(p => {
          if (!p.noNav) {
            return (
              <NavLink key={p.name} to={{
                ...location,
                pathname: p.path,
              }}>
                {p.name}
              </NavLink>
            );
          }
        })}
      }
    />
  );

  comp.NavLayout = ({ location }) => {
    return config.pages.map(p => {
      const navList = [];
      const content = [];
      p.children.map(p => {
        // 添加左侧菜单外链跳转逻辑
        const { companyid } = qs.parse(window.location.search);
        let h = false
        // todo 加入特殊判断 // 除指定公司外 其他全隐藏
        // companyid * 1 === 1 测试环境暂时放开
        if(process.env.NODE_ENV === "production") {
          const _companyid = companyid * 1
          // _companyid
          // 结算账户
          // 北京清研灵智科技有限公司 7
          // 优数研科环境科技（北京）有限公司 1451011
          // 北京数太奇科技有限公司 32
          // 贵州清研灵智信息咨询有限公司 1451012
          // 北京奕捷科技有限责任公司 1450982
          // 北京达洲信息咨询有限公司 1451052
          // 北京清研灵智文化传播有限公司 1451082
          // if([7, 1451011, 32, 1451012, 1450982, 1451052, 1451082].includes(_companyid)) {
          //   h = true
          // }
          h = true
        } else {
          h = true
        }
        if(p.open && h) {
          navList.push(
            <a key={p.name} onClick={()=> {
              p.openLink()
            }} target="_blank">
              <div>
                {p.name}
              </div>
            </a>
          );
        }
        if (!p.noNav && !p.open) {
          navList.push(
            <NavLink key={p.name} to={{
              ...location,
              pathname: p.path,
            }}>
              {/* {p.icon && <p.icon />} */}
              <div>
                {p.name}
              </div>
            </NavLink>
          );
        }
        content.push(
          <Route key={p.name} path={p.path} component={p.component} />
        );
      });

      return (
        <Route
          key={"NavLayout" + p.path}
          path={p.path}
          component={() => (
            <NavLayout
              NavList={() => {
                return navList;
              }}
              MyContent={() => {
                return content;
              }}
            />
          )}
        />
      );
    });
  }

  return comp;
}

function LinkButton({ to, showText }) {
  return (
    <a href={to}>
      <Button type="primary">{showText}</Button>
    </a>
  );
}

/**
 * header right
 */
const RenderRight = React.memo(withUser(function RenderRight({ user }) {
  const [noticNum, setNoticNum] = useState(0);
  const { domainId, companyid, token } = qs.parse(window.location.search);
  const self = user.self
  const btns = useRef([
    {
      path: company.prefix,
      to: userSelf.startPage,
    },
    {
      path: userSelf.prefix,
      to: company.startPage
    }
  ])
  if (!self) {
    return null;
  }
  const getNotice = () => {
    console.log(token);
    getInformOutLines({ token }).then(data => {
      setNoticNum(data.allCount);
      // console.log(Messages, 'fghsdgfhsgdhf');
    });
  }
  if(window.location.pathname.indexOf("/mymymanager")===-1){
    getNotice();
  }

  const searchInitData = {
    informType: "SYSTEM_INFORM",
    status: "NOT_READ",
    serviceType: null,
    page: 0,
    size: 5,   
  }
  return [
    // 新版入口 2022-4-2
    // <LinkButton style={{ borderRadius: 10, background: '#2775E8'  }} to={`${loginAfterUrl()}?companyid=${self.company && self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`} showText="去往新版>" />,
    <div>
      {
        window.location.pathname.indexOf("/mymymanager")===-1 ? (
          <a href={`${loginAfterUrl()}?companyid=${self.company && self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`}>
            <Button style={{ width: 99, borderRadius: 20, border: '0px solid #000' }} ref={(node) => {
              if(node){
                node.style.setProperty('background', '#2775E8', 'important')
              }
            }} type="primary">{`使用新版 〉`}</Button>
          </a>
        ) : (
          ""
        )
      }
    </div>,
    <Popover content={<NoticeInfoAlert updateTopFn={getNotice} />}>
      {!cookies.get("dingzhiBol") && !user.self.qingyan && (
        <div style={{ marginRight: 15 }}>
          <Badge count={noticNum}  >
            <BellOutlined style={{ fontSize: 20, color: 'white' }} title="消息中心" />
          </Badge>
        </div>
      )}
    </Popover>,
    <span className="helpBox">
      {
        !cookies.get("dingzhiBol") && !user.self.qingyan && ( <a href="https://www.yuque.com/surveywork/help" target="_blank" ><QuestionCircleOutlined title="帮助中心" style={{ fontSize: 20, color: 'white', position: "relative", top: 3 }} /></a>)
      }
    </span>,
    // <Messages 
    //   token={token}
    //   searchInitData={searchInitData}
    //   companyid={companyid} 
    //   noticNum={noticNum} 
    //   getNotice={getNotice} 
    //   getInformOutLines={getInformOutLines}
    //   searchNotice={searchNotice}
    //   readedNotice={readedNotice}
    // />, 
    <Switch key="linkbutton">
      <Route
        path={btns.current[0].path}
        render={() => <LinkButton to={`/user/workbench/home?companyid=${self.company && self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`} showText="回到个人后台" />}
      />
      <Route
        path={btns.current[1].path}
        render={() => {
          console.log("会工作台测试", self)
          if (!self.company || !self.company.owner) {
            return null;
          }
          return <LinkButton to={`/company/staff/list?companyid=${self.company.companyId}${domainId ? `&domainId=${domainId}` : ''}`} showText="进入企业后台" />;
        }}
      />
      <Route
        path={btns.current[1].path}
        render={() => {
          return <LinkButton to={`/user/workbench/home${companyid ? `?companyid=${companyid}` : ''}${domainId ? `&domainId=${domainId}` : ''}`} showText="回到工作台" />;
        }}
      />
    </Switch>,
    <UserBox key="userbox" user={user} />
  ];
}));

const MyLogged = withUser(function MyLogged({ user, location, Page }) {
  if (!user.self) {
    return (
      <section className="page-box">
        <Spin spinning></Spin>
      </section>
    )
  }
  return (
    <Fragment>
      <Route exact path="/index" component={MyCompanys} />
      <Page user={user} location={location} />
      <Route component={Page.NavLayout} />
    </Fragment>
  );
});

export default function Index({ location, match }) {
  const Page = pageMap.get("/" + match.params.group);
  if (!Page) {
    return null;
  }

  return (
    <UserContextWrapped>
      <HeaderBar
        renderLeft={<Page.HeaderLeft />}
        renderRight={<RenderRight />}
      />
      <MyLogged Page={Page} location={location} />
    </UserContextWrapped>
  );
}
/* eslint-disable */